export default __webpack_public_path__ + "static/media/doctor-short.5b9fbbf4.png";